/*
 * Newsletter
 *
 */

import NewsletterView from './View';

export function Newsletter() {
  return <NewsletterView />;
}
export default Newsletter;
